import React from "react";

import { observer } from "mobx-react";
import { lighten } from "polished";
import PropTypes from "prop-types";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { useTheme } from "styled-components";

function CustomSelect(props) {
  const { isAsync, selectRef, instanceId, id, ...rest } = props;

  const theme = useTheme();

  const selectTheme = (providedTheme) => ({
    ...providedTheme,
    borderRadius: 0,
    colors: {
      ...providedTheme.colors,
      primary: theme.primaryColor,
      primary25: lighten(0.4, theme.primaryColor),
      primary50: lighten(0.3, theme.primaryColor),
      primary75: lighten(0.4, theme.primaryColor),
    },
  });

  const SelectComponent = isAsync ? AsyncSelect : Select;

  // instanceId and inputId must be stable across server/client to prevent hydration mismatch
  const stableId = instanceId || id;
  return (
    <SelectComponent
      {...rest}
      ref={selectRef}
      theme={selectTheme}
      instanceId={stableId}
      inputId={id}
    />
  );
}

export default observer(CustomSelect);

CustomSelect.propTypes = {
  isAsync: PropTypes.bool,
  id: PropTypes.string,
  instanceId: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  selectRef: PropTypes.object,
};

CustomSelect.defaultProps = {
  isAsync: false,
  id: null,
  instanceId: null,
  selectRef: null,
};
